<template>
    <div class="note-item">
        <time :datetime="note.date" class="time">{{note.date}}</time>
        <span v-show="!edit" @click="editCLick" title="Редактировать" class="js-edit-note">
            <icon-base width="17" height="17" viewBox="0 0 17 17" icon-name="Редактировать"><icon-pencil fill="#178F7E"/></icon-base>
        </span>
        <component :is="currComponent" :type="'textarea'" :value="text" @input="text=$event" @enter="enterHandle"></component>
        <div v-if="edit" class="btns-box">
            <button type="button" class="text-btn js-save-btn" @click="editCLick">Сохранить</button>
        </div>
    </div>
</template>

<script>

    import FieldWrapper from "../common/fields/FieldWrapper";
    import FieldWrapperDisabled from "../common/fields/FieldWrapperDisabled";
    import IconBase from "../common/IconBase";
    import IconPencil from "../common/icons/IconPencil";
    export default {
        name: 'note-item',
        components: {IconPencil, IconBase, FieldWrapperDisabled, FieldWrapper},
        data() {
            return {
                edit: false,
                text: ''
            }
        },
        computed: {
            currComponent() {
                return this.edit ? 'field-wrapper' : 'field-wrapper-disabled'
            }
        },
        props: {
            note: Object,
        },
        methods: {
            editCLick() {
                if (this.edit) {
                    this.$emit('edit', this.text)
                }
                this.edit = !this.edit;
            },
            enterHandle() {
                this.$emit('edit', this.text)
                this.edit = !this.edit;
            }
        },
        created() {
            this.text = this.note.text
        }
    }
</script>

<style scoped>

</style>
